import { useState } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';

import { durationMap } from '../../durationMap';
import DeleteButton from '../../../../../../common/components/DeleteButton/DeleteButton';
import EditNotificationSettingForm from '../EditNotificationSettingForm';
import Button from '@mui/material/Button';
import ActionGroup from '../../../../../../common/components/ActionGroup';
import Modal from '../../../../../../common/components/Modal';
import {Permission} from "../../../../../../components/SessionInfo";
import {hetch} from "../../../../../../utils/fetch.hooked";

function NotificationSettingsTableRow({ row, triggerRefetch, permission }) {
  const [isFetching, setIsFetching] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const openEditModal = () => setEditModalOpen(true);
  const handleEditModalClose = () => setEditModalOpen(false);
  const removeItem = () => {
    setIsFetching(true);
    hetch(`/api/notification_settings/${row.id}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'DELETE',
      body: null
    })
      .then(() => {
        triggerRefetch();
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  return (
    <>
      <TableRow sx={{'&:last-child th': {border: 0}}}>
        <TableCell>{row.number}</TableCell>
        <TableCell>{row.count}</TableCell>
        <TableCell>{durationMap[row.duration_id]}</TableCell>
        { permission === Permission.WRITE
            ?   <TableCell>
                <ActionGroup align="right">
                  <Button
                    title="Редактировать настройку уведомлений"
                    variant="contained"
                    color="primary"
                    disabled={isFetching}
                    onClick={openEditModal}
                  >
                    <EditIcon />
                  </Button>
                  <DeleteButton
                    title="Удалить настройку уведомлений"
                    message="Вы действительно хотите удалить настройку уведомлений?"
                    isFetching={isFetching}
                    onConfirm={removeItem}
                  />
                </ActionGroup>
              </TableCell>
            : null
        }
      </TableRow>
      <Modal
        header="Редактирование настройки уведомлений"
        open={editModalOpen}
        onClose={handleEditModalClose}
      >
        <EditNotificationSettingForm {...row} triggerRefetch={triggerRefetch} handleClose={handleEditModalClose}/>
      </Modal>
    </>
  );
}

export default NotificationSettingsTableRow;
